import React from 'react'
import moment from 'moment'
import DayPickerInput from 'react-day-picker/DayPickerInput'
import MomentLocaleUtils, {formatDate, parseDate} from 'react-day-picker/moment'
import 'moment/locale/ro'
import 'moment/locale/de'
import 'moment/locale/fr'
import 'moment/locale/it'
import 'moment/locale/es'

export default class DatePicker extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            locale: this.props.locale || 'en',
            date: moment(this.props.date || new Date()).toDate(),
            hiddenDate: `${formatDate(this.props.date || new Date(), 'YYYY-MM-DD')}`
        }
        moment.locale(this.state.locale)
    }

    getSelection = () => {
        return this.state.hiddenDate
    }

    onChangeDate = (day) => {
        this.setState({date: day, hiddenDate: `${formatDate(day, 'YYYY-MM-DD')}`})
        this.props.onChangeDate && this.props.onChangeDate(day)
    }

    updateFromStart = (start_date) => {
        if(this.state.date < moment(start_date))
        {
            this.setState({date: moment(start_date), hiddenDate: `${formatDate(start_date, 'YYYY-MM-DD')}`})
        }
    }

    render() {
        return (
            <div>
                <input type="hidden" name={this.props.field_name} id={this.props.field_id} value={this.state.hiddenDate}/>
                <DayPickerInput inputProps={{className: "form-control"}}
                    onDayChange={this.onChangeDate}
                    month={this.state.date}
                    fromMonth={moment().toDate()}
                    selectedDays={this.state.date}
                    formatDate={formatDate}
                    parseDate={parseDate}
                    format="LL"
                    value={`${formatDate(this.state.date, 'LL', this.state.locale)}`}
                    placeholder='false'
                    dayPickerProps= {{
                        locale: this.state.locale,
                        localeUtils: MomentLocaleUtils,
                        disabledDays: {before: new Date()}
                    }}
                    />
            </div>
        )
    }
}